import {GetInvoices} from 'domain/usecases';
import {RemoteGetInvoices} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {MyPaymentsFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetInvoices = (): GetInvoices =>
	new RemoteGetInvoices(
		makeBFFApiUrl(MyPaymentsFlowEndPoints.invoices),
		makeAuthorizeHttpClientDecorator(),
	);
